import moment from "moment";
import React from "react";
import {
  DATE_FORMAT,
  payInFullText,
  payInFullWeeklyQuest,
  payMonthlyText,
  payTermText,
} from "../Common/commonMethods";
import {
  cardAndBankChargesHelper,
  cardAndBankChargesWithTotalHelper
} from "../Common/enrolmentHelpers"
const today = moment(new Date()).format(DATE_FORMAT);

const currentYear = moment(today, DATE_FORMAT).format("YYYY");

const currentyearFreeKitStartDate = `01/01/${currentYear}`;
const currentyearFreeKitEndDate = `31/03/${currentYear}`;

const isBetweenDates = moment(today, DATE_FORMAT).isBetween(
  moment(currentyearFreeKitStartDate, DATE_FORMAT),
  moment(currentyearFreeKitEndDate, DATE_FORMAT),
  undefined,
  "[]"
);

const PaymentMessage = ({
  paymentOption,
  isQuestWeekly,
  kitMandatory,
  priceObject,
  questForm,
  selectClass,
  questSetting,
  gingerSetting,
  business,
  paymentType
}) => {
  return (
    <div className="col-md-12">
      {paymentOption === "full" ? (
        <div className="mandate-acceptance mt-2">
          <h5>What does PAY IN FULL mean?</h5>
          <p>{questForm ? payInFullWeeklyQuest : payInFullText}</p>
        </div>
      ) : //  selectedClass?.service?.service !== "Childcare Fun Soccer" &&
      paymentOption === "monthly" ? (
        <div className="mandate-acceptance mt-2">
          <h5>
            <strong>Ongoing monthly price:</strong>
          </h5>
          <p>
              ${selectClass?.unit_price} per week, working out to ${selectClass?.unit_price * 4} most months, but depending on how
            many sessions are in the month (and we don't play on public
            holidays).
          </p>
          <br />
          <h5>
            <strong>What you are being charged today:</strong>
          </h5>
          <p></p>

          {/* {priceObject?.totalOrderAmount ? ( */}
          <div style={{ fontSize: "15px" }}>
            <p>
              <strong>Kit:</strong>{" "}
              {priceObject ? "$" + priceObject?.totalOrderAmount : 0}
            </p>
            <p>
              {/* THIS MONTH'S FEES: {priceObject ? "$" + priceObject?.classPrice : 0} */}
              <strong>Sessions:</strong>{" "}
              {priceObject ? "$" + priceObject?.classPrice : 0}
            </p>
            <p>
              {/* THIS MONTH'S FEES: {priceObject ? "$" + priceObject?.classPrice : 0} */}
              <strong>Admin Fee:</strong>{" "}
              {priceObject ? "$" + priceObject?.adminFee : 0}
            </p>

              { parseFloat(priceObject?.totalOrderAmount) +
                parseFloat(priceObject?.classPrice) +
                parseFloat(priceObject?.adminFee)
                > 0  ? 
              <p>
                {/* THIS MONTH'S FEES: {priceObject ? "$" + priceObject?.classPrice : 0} */}
                  <strong>Transaction Fee:</strong>{" "}
                  {
                    "$" +
                      cardAndBankChargesHelper(
                        parseFloat(priceObject?.totalOrderAmount) +
                        parseFloat(priceObject?.classPrice) +
                        parseFloat(priceObject?.adminFee)
                        , business == "ginger"
                          ?
                          paymentType == "credit" ? gingerSetting.stripe_fee_cc : gingerSetting.stripe_fee_bank
                          :
                          paymentType == "credit" ? questSetting.stripe_fee_cc : questSetting.stripe_fee_bank)
                  }
              </p>
              : <div>
                  <strong>Transaction Fee:</strong>{" "}$0
              </div>
                }

            <hr />
            {/* ) : null} */}

            <p>
              <strong>Total Price:</strong> $
              {priceObject
                ?
                  // cardAndBankChargesWithTotalHelper(
                  //   parseFloat(priceObject?.totalOrderAmount) +
                  //   parseFloat(priceObject?.classPrice) +
                  //   parseFloat(priceObject?.adminFee)
                  //   ,
                  //   business == "ginger"
                  //     ?
                  //     paymentType == "credit" ? gingerSetting.stripe_fee_cc : gingerSetting.stripe_fee_bank
                  //     :
                  //     paymentType == "credit" ? questSetting.stripe_fee_cc : questSetting.stripe_fee_bank
                  //   )
                  parseFloat(priceObject?.totalAmountToPay).toFixed(2)
                : 0}
            </p>
          </div>
          <br />
          <h5>
            <strong>What does PAY MONTHLY mean?</strong>
          </h5>
          <p>{payMonthlyText}</p>
        </div>
      ) : (
        // selectedClass?.service?.service !== "Childcare Fun Soccer" &&
        paymentOption === "term" && (
          <div className="mandate-acceptance mt-2">
            <h5>
              <strong>What does pay for the term mean?</strong>
            </h5>
            <p>{payTermText}</p>
          </div>
        )
      )}
    </div>
  );
};

export default PaymentMessage;
